import type { HeadlineResponse } from '@on3/api';
import { Link } from '@on3/ui-lib/components/Link';
import clsx from 'clsx';

import styles from './TopHeadlines.module.scss';

interface ITopHeadlinesListProps {
  list: HeadlineResponse[];
  heading: string;
  links?: {
    title: string;
    href: string;
  }[];
  isModule?: boolean;
  variant?: 'default' | 'secondary';
}
export const TopHeadlinesList = ({
  list,
  heading,
  links = [],
  isModule = false,
  variant = 'default',
}: ITopHeadlinesListProps) => {
  if (!list.length) return null;

  return (
    <section
      className={clsx(styles.block, {
        [styles.module]: isModule,
      })}
      data-variant={variant}
    >
      <h2 className={styles.heading}>{heading}</h2>
      <ul className={styles.list} data-headlines-list>
        {list.map(({ key, primaryCategory, fullUrl, title }) => (
          <li data-ui="top-headline" key={key}>
            <article className={styles.article}>
              <Link className={styles.category} href={primaryCategory?.fullUrl}>
                {primaryCategory?.name}
              </Link>
              <Link className={styles.title} href={fullUrl}>
                <h3>{title}</h3>
              </Link>
            </article>
          </li>
        ))}
      </ul>
      {links.length && (
        <footer className={styles.footer}>
          {links.map((link, index) => (
            <Link className={styles.footerLink} href={link.href} key={index}>
              {link.title}
            </Link>
          ))}
        </footer>
      )}
    </section>
  );
};
